import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export const useLocalisationAA = () => {
  /**
   * This does not do anything other than call statsig for exposures
   */
  useStatsigExperiment(STATSIG_EXPERIMENTS.A_A_LOCALISATION_ALL)
  useStatsigExperiment(STATSIG_EXPERIMENTS.A_A_LOCALISATION_CA_ONLY)
  useStatsigExperiment(STATSIG_EXPERIMENTS.A_A_LOCALISATION_US_ONLY)
}
